import axios from 'axios';

const changeEmail = (data) => (
  axios.post(
    `${process.env.REACT_APP_USER_API_ENDPOINT}/auth/email/change`,
    data,
  ));

export default changeEmail;
